declare namespace $ {

	type $mol_view__sub_bog_smalljs_lab_1 = $mol_type_enforce<
		ReturnType< $bog_smalljs_lab['race_options'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_lab_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_lab_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_lab_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_smalljs_lab_5 = $mol_type_enforce<
		ReturnType< $bog_smalljs_lab['virtual_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_scroll__sub_bog_smalljs_lab_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_view__sub_bog_smalljs_lab_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_lab_8 = $mol_type_enforce<
		ReturnType< $bog_smalljs_lab['leak_probes'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_lab_9 = $mol_type_enforce<
		ReturnType< $bog_smalljs_lab['crash_cards'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_scroll__sub_bog_smalljs_lab_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_view__sub_bog_smalljs_lab_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_lab_option__click_bog_smalljs_lab_12 = $mol_type_enforce<
		ReturnType< $bog_smalljs_lab['race_option_click'] >
		,
		ReturnType< $bog_smalljs_lab_option['click'] >
	>
	type $bog_smalljs_lab_option__current_bog_smalljs_lab_13 = $mol_type_enforce<
		ReturnType< $bog_smalljs_lab['race_option_current'] >
		,
		ReturnType< $bog_smalljs_lab_option['current'] >
	>
	type $bog_smalljs_lab_option__title_bog_smalljs_lab_14 = $mol_type_enforce<
		ReturnType< $bog_smalljs_lab['race_option_label'] >
		,
		ReturnType< $bog_smalljs_lab_option['title'] >
	>
	type $mol_view__sub_bog_smalljs_lab_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_smalljs_lab_16 = $mol_type_enforce<
		ReturnType< $bog_smalljs_lab['virtual_row_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_smalljs_lab_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_lab_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_lab_probe__label_bog_smalljs_lab_19 = $mol_type_enforce<
		ReturnType< $bog_smalljs_lab['leak_probe_label'] >
		,
		ReturnType< $bog_smalljs_lab_probe['label'] >
	>
	type $mol_view__sub_bog_smalljs_lab_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_lab_card__name_bog_smalljs_lab_21 = $mol_type_enforce<
		ReturnType< $bog_smalljs_lab['crash_card_name'] >
		,
		ReturnType< $bog_smalljs_lab_card['name'] >
	>
	type $bog_smalljs_lab_card__text_bog_smalljs_lab_22 = $mol_type_enforce<
		ReturnType< $bog_smalljs_lab['crash_card_text'] >
		,
		ReturnType< $bog_smalljs_lab_card['text'] >
	>
	export class $bog_smalljs_lab extends $mol_view {
		mol_theme( ): string
		case_content( ): readonly(any)[]
		race_options( ): readonly(any)[]
		Race_options( ): $mol_view
		race_panel_name( ): string
		Race_panel_name( ): $mol_view
		race_panel_descr( ): string
		Race_panel_descr( ): $mol_view
		Race_panel( ): $mol_view
		race_option_click( id: any, next?: any ): any
		race_option_current( id: any): boolean
		race_option_label( id: any): string
		virtual_rows( ): readonly(any)[]
		Virtual_list( ): $mol_list
		Virtual_scroll( ): $mol_scroll
		virtual_row_text( id: any): string
		virtual_placeholder( ): string
		leak_hint( ): string
		Leak_hint( ): $mol_view
		leak_probes( ): readonly(any)[]
		Leak_place( ): $mol_view
		leak_probe_label( id: any): string
		crash_cards( ): readonly(any)[]
		Crash_list( ): $mol_view
		Crash_scroll( ): $mol_scroll
		crash_card_name( id: any): string
		crash_card_text( id: any): string
		lights( next?: string ): string
		attr( ): ({ 
			'versus_lights': ReturnType< $bog_smalljs_lab['lights'] >,
			'mol_theme': ReturnType< $bog_smalljs_lab['mol_theme'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): ReturnType< $bog_smalljs_lab['case_content'] >
		Race( ): $mol_view
		Race_option( id: any): $bog_smalljs_lab_option
		Virtual( ): $mol_view
		Virtual_row( id: any): $mol_paragraph
		Virtual_placeholder( ): $mol_view
		Leak( ): $mol_view
		Leak_probe( id: any): $bog_smalljs_lab_probe
		Crash( ): $mol_view
		Crash_card( id: any): $bog_smalljs_lab_card
	}
	
	export class $bog_smalljs_lab_option extends $mol_button_minor {
		current( ): boolean
		attr( ): ({ 
			'versus_current': ReturnType< $bog_smalljs_lab_option['current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
	}
	
	export class $bog_smalljs_lab_probe extends $mol_view {
		label( ): string
		sub( ): readonly(any)[]
	}
	
	export class $bog_smalljs_lab_card extends $mol_view {
		name( ): string
		text( ): string
		attr( ): ({ 
			'versus_card': string,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=lab.view.tree.d.ts.map